import { LABELLING_TYPE } from '../../../../common/constant/constant';
import { binarySearchClosest } from '../../../../common/utils/binary-search';
import type { PTSTimestampTable } from '../../../../workers/types/video-frame-processor';
import { SPEED_OPTIONS } from '../../constants';
const DEFAULT_PLAY_SPEED = 1;
export const getDefaultPlaySpeed = () => SPEED_OPTIONS.includes(DEFAULT_PLAY_SPEED) ? DEFAULT_PLAY_SPEED : SPEED_OPTIONS[0];
export const getInitialFrameLoadStatus = (frameCount: number, fileType) => new Array(frameCount).fill(fileType === LABELLING_TYPE.PDF);

// Finds the closest frame number to a given timestamp using binary search on the PTS table.
export const findClosestFrameByTimestamp = (frameTable: PTSTimestampTable, timeStamp: number): number => {
  return binarySearchClosest<{
    timestamp: number;
  }>(frameTable, timeStamp, frame => frame.timestamp);
};